var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "dqre65ri6a",
    d: "M40 20c0 11.046-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0s20 8.954 20 20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bry6mi8zhc",
    d: "M1.985 20c0-4.411 3.59-8 8-8 4.411 0 8 3.589 8 8h-16zm5-13V5c0-1.654 1.346-3 3-3s3 1.346 3 3v2c0 1.654-1.346 3-3 3s-3-1.346-3-3zm6.435 3.618c.998-.939 1.564-2.248 1.565-3.618V5c0-1.326-.527-2.598-1.464-3.536C12.583.527 11.31 0 9.985 0c-2.762 0-4.97 2.239-4.97 5v2c-.01 1.366.545 2.676 1.534 3.619C2.615 12.061.004 15.81.014 20v1c0 .55.421 1 .971 1h18c.55 0 1-.45 1-1v-1c0-4.314-2.737-7.979-6.565-9.382z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "kq3yandyab",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dqre65ri6a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#E3ECF5",
    fillRule: "nonzero",
    xlinkHref: "#dqre65ri6a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#E9EEEF",
    mask: "url(#kq3yandyab)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M23.42 19.618c.998-.939 1.564-2.248 1.565-3.618v-2c0-2.761-2.239-5-5-5s-4.97 2.24-4.97 5v2c0 1.428.576 2.707 1.535 3.618-3.933 1.444-6.544 5.192-6.535 9.382v1c0 .55.42 1 .97 1h18c.55 0 1-.45 1-1v-1c0-4.314-2.736-7.979-6.565-9.382"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 9)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mw3hokmrrd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bry6mi8zhc"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#8FB0D4",
    fillRule: "nonzero",
    xlinkHref: "#bry6mi8zhc"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ADB8BE",
    mask: "url(#mw3hokmrrd)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    transform: "translate(-10 -9)"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "#ADB8BE"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.99d1c3919aa905497b9bddb75eebb0ab.svg";
export { ForwardRef as ReactComponent };